<!-- pages/catalog/[categoryId]/[subCategorySlug].vue -->
<script setup>
import Catalog from "~/components/Catalog.vue";

const route = useRoute();
</script>

<template>
    <Catalog :categoryId="route.params.categoryId" :subCategorySlug="route.params.subCategorySlug" />
</template>
